import { Component, Input, ElementRef, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-hero-image-slider',
    templateUrl: './hero-image-slider.component.html',
    styleUrls: ['./hero-image-slider.component.scss']
})
export class HeroImageSliderComponent implements OnInit, OnDestroy {

    @Input() scrollLeftPaddingPx: number = 20;
    @Input() heroes: any;

    @Output() focused = new EventEmitter();

    @ViewChild('imageSlider') imageSlider;

    currentFocus: number = 0;
    goingRight: boolean = true;
    slideInterval: any;


    constructor() {
    }

    ngOnInit(): void {
        this.slideInterval = setInterval(() => {
            /**
             * Skip will be true when a user has focused one of the hero banners, which stops the automatic rotation of banners.
             */
            let skip: boolean = false;

            for (let i = 0; i < this.heroes.length; i++) {
                if (document.activeElement === document.getElementById('hero-banner-' + i)) {
                    skip = true;
                    break;
                }
            }
            if (skip === false) {
                /**
                 * If the next banner wouldn't exist, go left.
                 */
                if (this.currentFocus + 1 >= this.heroes.length) {
                    this.goingRight = false;
                }

                /**
                 * If the index of the next banner would be -1, go right.
                 */
                if (this.currentFocus - 1 < 0) {
                    this.goingRight = true;
                }

                let nextBannerIndex: number = this.goingRight ? this.currentFocus + 1 : this.currentFocus - 1;

                let ele = document.getElementById('hero-banner-' + nextBannerIndex.toString());
                this.scrollIntoView(ele);
                this.currentFocus = nextBannerIndex;
            }
        }, 7000);
    }

    ngOnDestroy() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }
    }

    scrollIntoView(element: any) {
        if (!this.imageSlider || !element) {
            return;
        }

        const scrollElem: any = this.imageSlider.nativeElement;
        const scrollElX = scrollElem.getBoundingClientRect().x;
        const x = element.getBoundingClientRect().x - scrollElX;

        scrollElem.scrollLeft += (x - this.scrollLeftPaddingPx);
    }
}
